import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=bf27cba0&"
import script from "./FormView.vue?vue&type=script&lang=js&"
export * from "./FormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports